import type { UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useMemo } from "react";

/**
 * Wraps a `UseModalState` so that `closeModal` becomes a no-op while
 * `canClose` is `false`. Useful when a modal hosts an in-flight async
 * operation and should not be dismissed via swipe, backdrop tap, or the
 * cancel button until the operation settles.
 *
 * All other modal-state fields (e.g. `modalIsOpen`, `openModal`) are
 * forwarded unchanged.
 */
export function useGuardedModalState(modalState: UseModalState, canClose: boolean): UseModalState {
  return useMemo(
    () => ({
      ...modalState,
      closeModal: () => {
        if (!canClose) {
          return;
        }
        modalState.closeModal();
      },
    }),
    [modalState, canClose]
  );
}
